import exceljs from "exceljs";
import fs from "file-saver";
import { createdAtToUTC } from "../../utils/date";

const convertDateFormat = (timestamp) => {
    if(!timestamp) return "";
    const dateObject = new Date(timestamp);

    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = dateObject.getDate().toString().padStart(2, '0');
    const hours = dateObject.getHours().toString().padStart(2, '0');
    const minutes = dateObject.getMinutes().toString().padStart(2, '0');
    const seconds = dateObject.getSeconds().toString().padStart(2, '0');

    const newDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    timestamp = newDate;
    return timestamp;
}

export function getXLSXHeader(serviceName) {

    switch (serviceName) {
        case "veridoc":
            return [
                { header: "SESSION ID", key: "session_id" },
                { header: "PERSON ID", key: "person_id" },
                { header: "FIRST NAME", key: "first_name" },
                { header: "MIDDLE NAME", key: "middle_name" },
                { header: "LAST NAME", key: "last_name" },
                { header: "IIN", key: "iin" },
                { header: "ERROR", key: "error" },
                { header: "TIMESTAMP (UTC+6)", key: "timestamp" }
            ];
        case "veriface":
            return [
                { header: "SESSION ID", key: "session_id" },
                { header: "PERSON ID", key: "person_id" },
                { header: "SIMILARITY", key: "similarity" },
                { header: "TIMESTAMP (UTC+6)", key: "timestamp" }
            ];
        case "verilive":
            return [
                { header: "SESSION ID", key: "session_id" },
                { header: "PERSON ID", key: "person_id" },
                { header: "STATUS", key: "status" },
                { header: "TIMESTAMP (UTC+6)", key: "timestamp" }
            ];
        case "transactions":
            return [
              { header: "person_id", key: "person_id", width: 15 },
              { header: "flow_id", key: "flow_id", width: 30 },
              { header: "service_name", key: "service_name" },
              { header: "service_status", key: "service_status" },
              { header: "error_code", key: "error_code", width: 20 },
              { header: "session_status", key: "session_status" },
              // { header: "created_at_log", key: "created_at_log"},
              { header: "created_at", key: "created_at", width: 20 },
              // { header: "started_at", key: "started_at" },
              { header: "ended_at", key: "ended_at", width: 20 },
              { header: "frontend_session_status", key: "frontend_session_status", width: 20 },
            ];
        case "statistics":
            return [
              { header: "Total number of flows", key: "total_count" },
              { header: "Started Flows", key: "started_count" },
              { header: "Created flows", key: "created_count" },
              { header: "Succeed flows", key: "ended_count" },
              { header: "Failed flows", key: "failed_count" },
            ];
        default:
            return [];
    }
}

export function getXLSXRow(serviceName, document, worksheet) {
    switch (serviceName) {
        case "transactions":
            const services = document?.service_statuses || [];
            const startRow = worksheet.rowCount + 1;
            
            services.sort((a, b) => {
              const dateA = new Date(a?.created_at);
              const dateB = new Date(b?.created_at);
              return dateA - dateB;
            });

            services.forEach((service) => {
                worksheet.addRow({
                    person_id: document?.person_id,
                    flow_id: document?.flow_id,
                    service_name: service?.session_result?.service_name,
                    service_status: service?.session_result?.service_status,
                    error_code: service?.session_result?.error_code,
                    session_status: service?.session_status,
                    // created_at_log: convertDateFormat(service?.session_result?.created_at),
                    created_at: convertDateFormat(service?.created_at),
                    // started_at: convertDateFormat(service?.session_result?.start_time),
                    ended_at: convertDateFormat(service?.updated_at),
                    frontend_session_status: service?.frontend_session_status,
                });
            });

            const endRow = worksheet.rowCount;

            worksheet.mergeCells(`A${startRow}:A${endRow}`); // person_id
            worksheet.mergeCells(`B${startRow}:B${endRow}`); // flow_id
            break;
        
        case "statistics":
            worksheet.addRow({
                total_count: document?.total_count,
                started_count: document?.started_count,
                created_count: document?.created_count,
                ended_count: document?.ended_count,
                failed_count: document?.failed_count,
            })
            break;
        default:
            console.log("default");
    }
}


export function buildXLSX(serviceName, rawData, statistics) {

    const workbook = new exceljs.Workbook();
    const firstPage = "statistics";
    const secondPage = "transactions";

    const worksheet = workbook.addWorksheet(firstPage);
    worksheet.columns = getXLSXHeader(firstPage);
    getXLSXRow(firstPage, statistics, worksheet);

    const worksheet2 = workbook.addWorksheet(secondPage);
    worksheet2.columns = getXLSXHeader(secondPage);
    rawData.forEach((document) => {
      getXLSXRow(secondPage, document, worksheet2);
    });
    return workbook.xlsx.writeBuffer();
}

export function getBuffer(serviceName, rawData, fileExtension, statistics) {
    if (fileExtension === "xlsx") {
        return buildXLSX(serviceName, rawData, statistics);
    }
    return null;
}

export function getMimeType(fileExtension) {

    const mimeType = {
        "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };

    return mimeType[fileExtension];
}

export function saveFile(buffer, filename, mimeType) {
    const blob = new Blob([buffer], { type: mimeType });
    fs.saveAs(blob, filename);
}